<template>
  <div class="modal">
    <centered-container>
      <div class="modal-container">
        <div class="modal-close" @click="$emit('close')">
          <span aria-hidden="true">x</span>
        </div>
        <div class="modal-body">
          <slot>{{message}}</slot>
        </div>
        <div class="button-container">
          <div class="popup-button" v-if="cancelBtn" @click="$emit('cancelClick')">{{cancelBtn}}</div>
          <div class="popup-button" v-if="okBtn" @click="$emit('okClick')">{{okBtn}}</div>
        </div>
      </div>
    </centered-container>
  </div>
</template>

<script>
export default {
  name: "cms-popup",
  props: {
    cancelBtn: {
      type: String,
      default: null
    },
    okBtn: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
.modal {
  display: table-cell;
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: $modal-color;
}

.modal-container {
  background-color: white;
  margin: 1.5rem;
  border-radius: 1rem;
  min-width: 50%;
}

.modal-close {
  padding-left: 90%;
}

.modal-body {
  text-align: left;
  padding: 0 0.7rem 0.7rem 0.7rem;
}

.button-container {
  border-top: 1px solid $white-one-color;
}

.popup-button {
  display: inline-block;
  width: 50%;
  color: $blue-color;
  line-height: 2.5rem;
}

.popup-button:not(:first-child) {
  border-left: 1px solid $white-one-color;
}
</style>